import { render, staticRenderFns } from "./ReceivedList.vue?vue&type=template&id=38e7feec&"
import script from "./ReceivedList.vue?vue&type=script&lang=js&"
export * from "./ReceivedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports